import {Component, Input, OnInit} from '@angular/core';
import {BackendResponse} from "@app/interfaces/backendResponse";
import {BoardsService} from "@components/boards/boards.service";
import {ToastrService} from "ngx-toastr";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {ActivatedRoute, Router} from "@angular/router";
import {HelperService} from "@app/services/helper/helper.service";
import {StatusSettingsComponent} from "@common-components/status-settings/status-settings.component";
import {MatDialog} from "@angular/material/dialog";
import {Board} from "@components/boards/board-card/board-card.component";

interface List {
    id: string,
    head: string,
    items: any[],
    toggle: boolean,
    color: string
}

@Component({
    selector: 'app-board',
    templateUrl: './board.component.html',
    styleUrls: ['./board.component.css']
})

export class BoardComponent implements OnInit {

    id: string;
    newColumnName = '';

    loader = false;
    newColumnButton = false;

    list = [];

    board: Board = {
        _id: '',
        project_id: '',
        columns: [],
        name: '',
        status: '',
        tasks: [],
        projectData: {},
        createdAt: '',
        type: ''
    };

    color = 'red';
    // list = [
    //     {head: "to do", items: ["Get to work", "Pick up groceries", "Go home", "Fall asleep"]},
    //     {head: "Done", items: ["Get up", "Brush teeth", "Take a shower", "Check e-mail", "Walk dog"]},
    // ];
    constructor(private boardsService: BoardsService,
                private toastr: ToastrService,
                private router: Router,
                private helperService: HelperService,
                private matDialog: MatDialog,
                private route: ActivatedRoute
    ) {
    }


    ngOnInit() {
        this.loader = true;
        this.route.params.subscribe(async (params) => {
            if (params.boardId) {
                this.id = params.boardId;
                if (this.id !== '' && this.id) {
                    await this.getBoard();
                }
            }
        });

        this.loader = false;
    }

    openStatusSettings() {

        let dialog = this.matDialog.open(StatusSettingsComponent, {
            maxWidth: '370px',
            maxHeight: '560px',
            position: {top: '0'},
            data: {
                board_id: this.id
            }
        });
        dialog.afterClosed().subscribe(result => {
            
        });
    }

    dejana() {
    }


    addColumn(boardId) {
        if (this.newColumnName == '') return;
        this.boardsService.addNewColumnToBoard(boardId, this.newColumnName).subscribe(async (response: BackendResponse) => {
            if (response.type == 'success') {
                this.toastr.success(`Dodata je nova kolona ${this.newColumnName}`);
                this.newColumnButton = false;
                this.newColumnName = '';
                await this.getBoard();
            } else if (response.type === 'info') {
                this.toastr.info('Kolona sa unijetim imenom već postoji.');
            } else {
                this.toastr.error('Došlo je do greške prilikom dodavanja nove kolone. Molimo Vas obratite se korisničkoj podršci.');
            }
        })

    }


    getBoard() {
        return new Promise((resolve, reject) => {
            this.boardsService.getBoard(this.id).subscribe((responseData: BackendResponse) => {
                if (responseData.type == 'success') {
                    this.board = responseData.data;
                    this.list = [];
                    let data = responseData.data;
                    let columns: any[] = data['columns'];
                    if (columns) {
                        columns.sort((a, b) => {
                            return a.orderNumber - b.orderNumber;
                        });
// raspored taskova u kolone
                        columns.forEach(subitem => {
                            let listItem: List = {id: '', head: '', items: [], toggle: false, color: ''};
                            listItem.head = subitem.title;
                            listItem.id = subitem.id;
                            listItem.items = subitem.tasks;
                            listItem.color = subitem.color;
                            listItem.toggle = false;
                            let tasks: any[] = subitem.tasks;
                            tasks.forEach(x => {
                                let assigned = x['assigned'];
                                let assignedArray = this.helperService.getUserDataForIds(assigned);
                                x['assigned'] = assignedArray;
                            });
                            this.list.push(listItem);
                        });
                    }


                    resolve();
                } else reject();
            }, error1 => {
                reject(error1);
            })
        })
    }

    get trackIds(): string[] {
        return this.list.map(items => items.id);
    }

    dropColumns(event: CdkDragDrop<string[]>) {
        if (event.previousIndex === event.currentIndex) return;
        moveItemInArray(this.list, event.previousIndex, event.currentIndex);
        this.changeOrderNumber();
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            this.toastr.info('Zadatak mora biti premješten u kolonu različitu od trenutne.');
            return;
        }
        transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex
        );
        let id = event.item.data;


        // todo ovaj dio koda je potreban za pregled boardova

        // this.boardsService.transferTaskToColumn(id, event.container.id, this.id).subscribe((responseData: BackendResponse) => {
        //     if (responseData.type == 'success') {
        //
        //     } else {
        //         this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.');
        //     }
        // })


    }

    changeOrderNumber() {
        let data: any[] = this.list.map((item, index) => {
            return {id: item.id, index: index};
        });
        this.boardsService.changeColumnOrderNumber(this.board._id, data).subscribe((responseData: BackendResponse) => {
        });

    }

    colorPickerHandler(event, id) {
        this.boardsService.colorChange(this.id, id, event).subscribe((responseData: BackendResponse) => {
            if (responseData.type !== 'success') {
                this.toastr.error('Došlo je do greške prilikom odabira boje. Molimo Vas obratite se korisničkoj podršci.');
            }
        });
    }
}
